import React, { Component } from 'react';
import { Form, Row, Col, Card, Button } from 'react-bootstrap';
import { Redirect } from "react-router-dom";
import { fetchAndSetFlashMessage, Fetcher } from "../../../Helpers/fetcher.js";
import { Notify } from "../../../Helpers/notification.js";
import { cloneDeep, isEmpty } from 'lodash';
import "./index.css";
import ParameterTable from '../ParameterTable.js';
import SelectableBodyTable from "../SelectableBodyTable";  
import { CopyButton } from '../../WebhooksSms/CopyButton.js';

class AddWebhooks extends Component {
    constructor(props) {
        super(props);
        const protocol = window.location.protocol;
        const slashes = protocol.concat("//");
        const sitePath = slashes.concat(window.location.hostname);

        this.state = {
            userId: props.app.userId,
            apiPath: props.app.apiPath,
            sitePath: sitePath,
            webhookAdded: false,
            eventList: [],
            webhookname: '',
            webhookurl: '',
            eventName: '',
            headers: { "Content-Type": "application/json" },
            bodyTable: [],
            bodyParams: {},
            bodyParamsStd: {},
            customHeaderParam: '',
            customHeaderValue: '',
            customBodyParam: '',
            customBodyValue: '',
            markAsDefault: 0,
            alertMessage: '',
            showSampleJson: false
        };
    }

    componentDidMount() {
        const apiPath = this.state.apiPath;

        fetchAndSetFlashMessage(
            this.props.app.apiPath,
            msg => msg.moduleName === "webhook" && msg.action === "add",
            msg => this.setState({ alertMessage: msg })
        );

        Fetcher.get(apiPath + '/api/obd/webhooks/events')
            .then(res => this.setState({ eventList: res }))
            .catch(err => console.log('Error fetching Events', err));
        
        Fetcher.get(apiPath + '/api/obd/webhook/body/parameters')
            .then(res => {
                const table = res?.map((r, index) => {
                    return {
                        id: index + 1,
                        parameter: r.parameterName,
                        value: r.parameterName,
                        selected: true
                    }
                })
                const params = Object.fromEntries(
                    res.map(item => [item.parameterName, `{${item.parameterName}}`])
                )
                this.setState({
                    bodyParams: params,
                    bodyTable: table,
                    bodyParamsStd: params
                })
            })
            .catch(err => { console.log('Error in fetching Body Parameters', err) });

    }

    setvalue = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleCheckboxChange = (e) => {
        this.setState({ markAsDefault: e.target.checked ? 1 : 0 });
    };

    handleAddWebhooks = (event) => {
        event.preventDefault();

        const data = {
            webhookName: this.state.webhookname,
            url: this.state.webhookurl,
            event: this.state.eventName,
            userId: Number(this.state.userId),
            headerJson: JSON.stringify(this.state.headers),
            bodyJson: JSON.stringify(this.state.bodyParams),
            markAsDefault: this.state.markAsDefault
        };

        return Fetcher.post(this.props.app.apiPath + '/api/obd/addWebHooks', {
            headers: { "Content-type": "application/json" },
            method: 'POST',
            body: JSON.stringify(data)
        })
            .then(res => {
                Notify.notify(res.message);
                this.setState({ webhookAdded: res.message !== 'Parameters Incorrect' });
            })
            .catch(err => {
                console.log('Error Adding webhooks', err);
                Notify.notify('Error in Adding webhooks');
            });
    };

    handleAddCustomHeaderParam = () => {
        const trimmedParam = this.state.customHeaderParam.trim();
        const { headers } = this.state;

        if (!trimmedParam) return Notify.notify("Please fill parameter name");
        if (trimmedParam.includes(" ")) return Notify.notify("Parameter name cannot contain spaces");

        const exists = Object.keys(headers).some(
            key => key.toLowerCase() === trimmedParam.toLowerCase()
        );

        if (exists) return Notify.notify("This parameter has already been added");

        const value = this.state.customHeaderValue.trim() || trimmedParam;

        this.setState({
            headers: { ...headers, [trimmedParam]: value },
            customHeaderParam: '',
            customHeaderValue: ''
        });
    };

    handleRemoveHeader = (p) => {
        const updated = { ...this.state.headers };
        delete updated[p];
        this.setState({ headers: updated });
    };


    toggleBodySelect = (id) => {
        const bodyTable = this.state.bodyTable.map(row =>
            row.id === id ? { ...row, selected: !row.selected } : row
        );

        const bodyParams = {};
        bodyTable.filter(r => r.selected).forEach(r => {
            bodyParams[r.parameter] = r.custom
                ? r.value
                : `{${r.value}}`;
        });

        this.setState({ bodyTable, bodyParams });
    };

    toggleBodySelectAll = () => {
        const allSelected = this.state.bodyTable.every(r => r.selected);

        const bodyTable = this.state.bodyTable.map(r => ({
            ...r,
            selected: !allSelected
        }));

        const bodyParams = {};
        bodyTable.filter(r => r.selected).forEach(r => {
            bodyParams[r.parameter] = r.custom
                ? r.value
                : `{${r.value}}`;
        });

        this.setState({ bodyTable, bodyParams });
    };

    editBodyParameter = (id, newName) => {
        const trimmed = newName.trim();
        if (!trimmed) return Notify.notify("Parameter cannot be empty");

        const bodyTable = this.state.bodyTable.map(r => {
            if (r.id === id) {
                return {
                    ...r,
                    parameter: trimmed,
                };
            }
            return r;
        });

        const bodyParams = {};
        bodyTable.forEach(r => {
            if (r.selected) {
                bodyParams[r.parameter] = r.custom
                    ? r.value
                    : `{${r.value}}`;
            }
        });

        this.setState({ bodyTable, bodyParams });
    };


    handleAddCustomBodyParam = () => {
        const trimmedParam = this.state.customBodyParam.trim();

        if (!trimmedParam) return Notify.notify("Please enter parameter name");
        if (trimmedParam.includes(" ")) return Notify.notify("No spaces allowed");

        const exists = this.state.bodyTable.some(
            r => r.parameter.toLowerCase() === trimmedParam.toLowerCase()
        );

        if (exists) return Notify.notify("Parameter already exists");

        const customCount = this.state.bodyTable.filter(
            r => r.custom
        ).length;

        if (customCount >= 2) return Notify.notify("You can only add up to 2 custom parameters");

        const value = this.state.customBodyValue.trim() || trimmedParam;

        if (Object.keys(this.state.bodyParamsStd).includes(value)) {
            return Notify.notify("This value already exists in standard parameters");
        }

        const newRow = {
            id: this.state.bodyTable.length + 1,
            parameter: trimmedParam,
            value,
            selected: true,
            custom:true
        };

        const bodyTable = [...this.state.bodyTable, newRow];

        const bodyParams = {
            ...this.state.bodyParams,
            [trimmedParam]: value
        };

        this.setState({
            bodyTable,
            bodyParams,
            customBodyParam: '',
            customBodyValue: ''
        });
    };

    handleRemoveCustomParameter = (id) => {
        const bodyTable = this.state.bodyTable.filter(row => row.id !== id);

        const bodyParams = {};
        bodyTable.filter(r => r.selected).forEach(r => {
            bodyParams[r.parameter] = r.value;
        });

        this.setState({ bodyTable, bodyParams });
    };

    render() {
        if (this.state.webhookAdded) return <Redirect to="/webhook-list" />;

        const submitButtonlabel = "Add Webhook";

        const eventList = cloneDeep(this.state.eventList);
        let eventDropdown = "";

        if (!isEmpty(eventList) && !("error" in eventList)) {
            eventDropdown = Array.isArray(eventList)
                ? eventList.map((obj, index) => (
                      <option value={obj.eventName} key={index}>
                          {obj.eventName}
                      </option>
                  ))
                : [];
        } else {
            eventDropdown = <option value="">No Event found</option>;
        }

        const hasHeaders = Object.keys(this.state.headers).length > 0;
        const hasBodyParams = this.state.bodyTable.length > 0;

        return (
            <Form className="add-campaign-form" onSubmit={this.handleAddWebhooks}>
                <Row>
                    <Col sm={12}>
                        <Card>
                            {this.state.alertMessage && <marquee className="fade m-2 alert alert-success show">{this.state.alertMessage}</marquee>}
                            <Card.Header>Add Webhook</Card.Header>
                            <Card.Body>
                                <Row>
                                    <Col sm={3}>
                                        <Form.Group>
                                            <Form.Label>Webhook Name</Form.Label>
                                            <Form.Control
                                                required
                                                name="webhookname"
                                                value={this.state.webhookname}
                                                onChange={this.setvalue}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={3}>
                                        <Form.Group>
                                            <Form.Label>Webhook URL</Form.Label>
                                            <Form.Control
                                                required
                                                name="webhookurl"
                                                value={this.state.webhookurl}
                                                onChange={this.setvalue}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={3}>
                                        <Form.Group>
                                            <Form.Label>Event</Form.Label>
                                            <Form.Select
                                                required
                                                name="eventName"
                                                onChange={this.setvalue}
                                            >
                                                <option value="">Select Events</option>
                                                {eventDropdown}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col sm={3} className="mt-4">
                                        <Form.Group className="mt-2">
                                            <Form.Check
                                                type="checkbox"
                                                label="Make this as default"
                                                checked={this.state.markAsDefault === 1}
                                                onChange={this.handleCheckboxChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                {/* Headers Section */}
                                <Row className="mt-4">
                                    <Col sm={12}>
                                        <h5>Headers</h5>

                                        <Row className="mt-3">
                                            <Col sm={3}>
                                                <Form.Label>Parameter</Form.Label>
                                                <Form.Control
                                                    value={this.state.customHeaderParam}
                                                    placeholder="Parameter"
                                                    onChange={(e) =>
                                                        this.setState({
                                                            customHeaderParam: e.target.value
                                                        })
                                                    }
                                                />
                                            </Col>

                                            <Col sm={3}>
                                                <Form.Label>Value</Form.Label>
                                                <Form.Control
                                                    value={this.state.customHeaderValue}
                                                    placeholder="Value"
                                                    onChange={(e) =>
                                                        this.setState({
                                                            customHeaderValue: e.target.value
                                                        })
                                                    }
                                                />
                                            </Col>

                                            <Col sm={2} className="mt-2">
                                                <Button
                                                    className='mt-4 mb-0'
                                                    variant="primary"
                                                    size="sm"
                                                    onClick={this.handleAddCustomHeaderParam}
                                                >
                                                    <i className="fa fa-plus"></i> Add
                                                </Button>
                                            </Col>
                                        </Row>

                                        {hasHeaders && (
                                            <Row className="mt-2">
                                                <Col sm={hasHeaders ? 6 : 12}>
                                                    <ParameterTable
                                                        data={Object.keys(this.state.headers).map(
                                                            (key) => ({
                                                                parameter: key,
                                                                value: this.state.headers[key]
                                                            })
                                                        )}
                                                        onRemove={this.handleRemoveHeader}
                                                        showTable={true}
                                                    />
                                                </Col>

                                                {hasHeaders && <Col sm={4}>
                                                    <h6>Headers JSON</h6>
                                                    <pre style={{
                                                        backgroundColor: '#f8f9fa',
                                                        padding: '10px',
                                                        borderRadius: '5px',
                                                        maxHeight: '200px',
                                                        overflow: 'auto',
                                                        fontSize: '12px',
                                                        marginTop: '10px'
                                                    }}>
                                                        {JSON.stringify(this.state.headers, null, 2)}
                                                    </pre>
                                                    <CopyButton text={this.state.headers} className='custom-copy-button'/>
                                                </Col>}
                                            </Row>
                                        )}
                                    </Col>
                                </Row>

                                {/* Body Parameters Section */}
                                <Row className="mt-4">
                                    <Col sm={12}>
                                        <h5>Body</h5>
                                        <Row className="mt-3">
                                            <Col sm={3}>
                                                <Form.Label>Parameter</Form.Label>
                                                <Form.Control
                                                    value={this.state.customBodyParam}
                                                    placeholder="Parameter"
                                                    onChange={(e) =>
                                                        this.setState({
                                                            customBodyParam: e.target.value
                                                        })
                                                    }
                                                />
                                            </Col>

                                            <Col sm={3}>
                                                <Form.Label>Value</Form.Label>
                                                <Form.Control
                                                    value={this.state.customBodyValue}
                                                    placeholder="Value"
                                                    onChange={(e) =>
                                                        this.setState({
                                                            customBodyValue: e.target.value
                                                        })
                                                    }
                                                />
                                            </Col>

                                            <Col sm={2} className="mt-2">
                                                <Button
                                                   className='mt-4 mb-0'
                                                    variant="primary"
                                                    size="sm"
                                                    onClick={this.handleAddCustomBodyParam}
                                                >
                                                    <i className="fa fa-plus"></i> Add
                                                </Button>
                                            </Col>
                                        </Row>

                                        <Row className="mt-3">
                                            <Col sm={hasBodyParams ? 6 : 12}>
                                                <SelectableBodyTable
                                                    data={this.state.bodyTable}
                                                    onToggleSelect={this.toggleBodySelect}
                                                    onToggleSelectAll={this.toggleBodySelectAll}
                                                    onEditParameter={this.editBodyParameter}
                                                    onRemoveParameter={this.handleRemoveCustomParameter}
                                                    standardParameters={Object.keys(this.state.bodyParamsStd)}
                                                />
                                            </Col>

                                            {hasBodyParams && <Col sm={4}>
                                                <h6>Selected Body JSON</h6>
                                                <pre style={{
                                                        backgroundColor: '#f8f9fa',
                                                        padding: '10px',
                                                        borderRadius: '5px',
                                                        maxHeight: '200px',
                                                        overflow: 'auto',
                                                        fontSize: '12px',
                                                        marginTop: '10px'
                                                    }}>
                                                    {JSON.stringify(this.state.bodyParams, null, 2)}
                                                </pre>
                                                <CopyButton text={JSON.stringify(this.state.bodyParams, null, 2)} className='custom-copy-button'/>
                                            </Col>}
                                        </Row>
                                    </Col>
                                </Row>

                                <Row className="mt-4">
                                    <Col sm={12}>
                                        <Button variant="primary" type="submit">
                                            {submitButtonlabel}
                                        </Button>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Form>
        );
    }
}

export default AddWebhooks;
